import { useContext, useState } from "react";
import { HorizontalLayout, VerticalLayout } from "../layout";
import { IconButton, StandardButton } from "../../atoms/buttons";
import { TextAtom } from "../../atoms/TextAtom";
import { IconAtom, IconAtom2 } from "../../atoms/iconAtom";
import { Modal, ModalBody, ModalTitle } from "../modal";
import { Alert } from "../alert";
import { InputForm } from "../../atoms/input";
import ExpligoCard from "./ExpligoCard";
import ExpligoWP from "../../assets/expligo_wp2.png";
import { PageContext } from "../../App";
import { postAPI } from "../../api/api";

export default function CardInfo ({ cardInfo = {} }){
    const navigationContext = useContext(PageContext);
    const lead = cardInfo.lead; 
    console.log("lead in CardInfo component:", lead);
    const hasLead = lead?.id_lead;
    const handleGoBack = () => {
        navigationContext.handleNavigation({ navigation: 3 });
    }
    const handleNavigation = () => {
        if(navigationContext.sidebar){
          navigationContext.handleNavigation({ navigation: 3 });
        }
        else{
          window.location.reload();
        }
       
    }
    const createLead = async (leadData) => {
        const query = `/api/cards/create-lead`;
        const body = { ...leadData, id_card: cardInfo.id_card };
        const res = await postAPI(query, body);
        if (res.status === "ok") {
           handleNavigation();
        }
    };
    console.log("card info in card info component:", cardInfo);
    const [leadCreationModal, setLeadCreationModal] = useState(false);
  return (
    <>
    <VerticalLayout className="center-all tap-to-learn-wallpaper"style={{backgroundImage: `url(${ExpligoWP})`, }}>
       {navigationContext.sidebar && <StandardButton onClick={() => handleGoBack()} style={{ position: "absolute", top: "1rem", left: "1rem" }} backgroundColor="white" textColor="primary-700" arrow={"left"} />}
      {!leadCreationModal && <ExpligoCard style={{ width: "clamp(20rem, 50vw, 40rem)", height: "max-content", minHeight: "22rem", padding: "min(1rem, 1.5rem)"}} imageSize="15rem" content={
        <>
         {hasLead ? (
          <>
           <CardConnected lead={lead} />
          </>
        ) : (
          <CardNotConnected OnAddLead={() => setLeadCreationModal(true)} />
        )}
        </>
      } />}
    </VerticalLayout>
     <LeadCreationModal visible={leadCreationModal} dismiss={() => setLeadCreationModal(false)} createLead={createLead} />
     </>
  );
};


const CardConnected = ({ lead }) => {
  const createdDate = lead.activated_at
    ? new Date(lead.activated_at).toLocaleDateString("nl-NL", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : null;
  const infoItems = [
    { icon: "company", color: "primary-600", text: lead.company_name },
    { icon: "mail", color: "primary-600", text: lead.email },
    { icon: "phone", color: "primary-600", text: lead.phone_number },
  ];

  const statusItems = [
    {
      icon: lead.status === 1 ? "check-circle-no-fill" : "x-circle-no-fill",
      color: lead.status === 1 ? "success-500" : "error-500",
      text: lead.status === 1 ? "Actief" : "Niet actief",
    },
    {
      icon: "eye",
      color: "primary-600",
      text: `${lead.open_count || 0}x geopend`,
    },
    {
      icon: "clock",
      color: "primary-600",
      text: timeAgo(lead.last_opened),
    }
  ];

  return (
    <>
     {createdDate && (
        <TextAtom
          title={`${lead.status === 1 ? "Geactiveerd" : "Gemaakt"} op ${createdDate}`}
          className="standard-text-color-light absolute"
          style={{ width: "100%", fontSize: "0.85rem", textAlign: "right", top: "2rem", right: "2rem" }}
        />
      )}
      <TextAtom title={`${lead.first_name || ""} ${lead.last_name || ""}`.trim() || "Geen naam"} className="standard-text-color standard-margin-top standard-margin-bottom" style={{ fontSize: "1.25rem", fontWeight: 600 }} />
      {infoItems.map((item, i) => (
        <InfoRow key={i} {...item} />
      ))}
      <HorizontalLayout className="space-between standard-margin-top" style={{ borderTop: "1px solid var(--border-color)", }}>
        <StatusRow items={statusItems} />
      </HorizontalLayout>
    </>
  );
};


const CardNotConnected = ({OnAddLead}) => 
  {
    const navigationContext = useContext(PageContext);
  return(
  <VerticalLayout className="flex-start">
    <p className="standard-text-color standard-margin-top">
      Deze kaart is nog niet gekoppeld aan een lead. Je kunt zelf een lead toevoegen, 
      maar deze zal nog niet geactiveerd zijn.
    </p>
    <p className="standard-text-color standard-margin-top">
      {`Card ID: https://expligo.nl/tap-to-learn/${navigationContext.sidebar ? navigationContext.sidebar.cardInfo.uuid_card : "unknown"}`}
    </p>
    <StandardButton onClick={OnAddLead} style={{ margin: "auto 0 0 0", }} title={"Lead toevoegen"} />
  </VerticalLayout>
  )}


const InfoRow = ({ icon, color, text, size = 20 }) => {
  if (!text) return null;
  return (
    <HorizontalLayout style={{ gap: ".5rem", alignItems: "center" }}>
      <IconAtom2 color={color} icon2={icon} iconSize={size} />
      <TextAtom
        title={text}
        className="standard-text-color"
        style={{ fontSize: "0.9rem" }}
      />
    </HorizontalLayout>
  );
};

const StatusRow = ({ items = [] }) => (
  <HorizontalLayout className="standard-margin-top flex-start phone-card-icon" style={{ gap: "1rem",}} >
    {items.map(({ icon, color, text }, idx) => (
      <HorizontalLayout key={idx} style={{ alignItems: "center", gap: "0.25rem", width: "unset" }}>
        <IconAtom color={color} icon2={icon} iconSize={25} />
        <TextAtom
          title={text}
          className="standard-text-color-light"
          style={{ fontSize: "0.9rem" }}
        />
      </HorizontalLayout>
    ))}
  </HorizontalLayout>
);

const LeadCreationModal = ({ visible, dismiss, createLead }) => {
  const [createModalData, setCreateModalData] = useState({ first_name: "", last_name: "", email: "", company_name: "", phone_number: "" });
  const [message, setMessage] = useState("");
  const handleCreateLead = () => {
    if (!createModalData.first_name.trim() && !createModalData.last_name.trim() && !createModalData.email.trim()) {
      setMessage("Vul minimaal een voornaam, achternaam of e-mailadres in.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    if (createModalData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(createModalData.email)) {
      setMessage("Vul een geldig e-mailadres in.");
      setTimeout(() => setMessage(""), 3000);
      return;
    }
    createLead(createModalData);
    dismiss();
  }
  return (
    <Modal
      dismissable={dismiss}
      visible={visible}
      size="small"
      content={
        <>
          <ModalTitle
            dismissable={dismiss}
            hasXmark={true}
            title="Nieuwe lead toevoegen"
          />
          <ModalBody
            style={{ maxWidth: "500px" }}
            content={
              <>
                <Alert
                  type="info"
                  message="De lead ontvangt een welkomstmail op het opgegeven e-mailadres, maar zal nog niet geactiveerd zijn."
                  className="phone-alert-email standard-margin-bottom"
                />

                <HorizontalLayout style={{ gap: "1rem" }}>
                  <InputForm
                    value={createModalData.first_name}
                    typeInput={(v) => setCreateModalData(prev => ({ ...prev, first_name: v }))}
                    title="Voornaam"
                  />
                  <InputForm
                    value={createModalData.last_name}
                    typeInput={(v) => setCreateModalData(prev => ({ ...prev, last_name: v }))}
                    title="Achternaam"
                  />
                </HorizontalLayout>

                <InputForm
                  value={createModalData.email}
                  typeInput={(v) => setCreateModalData(prev => ({ ...prev, email: v }))}
                  title="E-mail"
                />

                <InputForm
                  value={createModalData.company_name}
                  typeInput={(v) => setCreateModalData(prev => ({ ...prev, company_name: v }))}
                  title="Bedrijfsnaam"
                  placeholder="Optioneel"
                />

                <InputForm
                  value={createModalData.phone_number}
                  typeInput={(v) => setCreateModalData(prev => ({ ...prev, phone_number: v }))}
                  title="Telefoonnummer"
                  placeholder="Optioneel"
                />
                {message && <Alert
                  type="error"
                  message={message}
                  className="phone-alert-email standard-margin-bottom"
                />}

                <HorizontalLayout
                  style={{ justifyContent: "flex-end", gap: "1rem", marginTop: "1rem" }}
                >
                  <StandardButton
                    className="secondary-button"
                    title="Annuleren"
                    onClick={dismiss}
                  />
                  <StandardButton title="Aanmaken" onClick={handleCreateLead} />
                </HorizontalLayout>
              </>
            }
          />
        </>
      }
    />
  );
};


const timeAgo = (date) => {
  if (!date) return "Nooit";

  const now = new Date();
  const past = new Date(date);
  const diff = Math.floor((now - past) / 1000);

  if (diff < 60) return `${diff} seconden geleden`;
  if (diff < 3600) return `${Math.floor(diff / 60)} minuten geleden`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} uur geleden`;
  if (diff < 604800) return `${Math.floor(diff / 86400)} dagen geleden`;
  
  return past.toLocaleDateString("nl-NL", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};
